import React, { useState, useEffect } from 'react';

const Loader = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`loading ${isLoading ? '' : 'hidden'}`}>
      <div className="loader"></div>
      <div className="loader-text">
        Loading...
      </div>
    </div>
  );
};

export default Loader;
